<template>
  <div>
    <topsearch title="Profil" />
    <div class="content-section ">
      <div class="grid  grid-cols-2  ">
        <!-- End Stats -->

        <!-- Stats -->
        <div v-if="userInfo.leads">
          <h4
            class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
          >
            Müşteri Adayı Sayısı
          </h4>
          <p class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600">
            {{ userInfo.leads.count }}
          </p>
        </div>
        <!-- End Stats -->

        <!-- Stats -->
        <div v-if="userInfo.customers">
          <h4
            class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
          >
            Müşteri Sayısı
          </h4>
          <p class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600">
            {{ userInfo.customers.count }}
          </p>
        </div>
        <div v-if="userInfo.customer_average_conversion_time">
          <h4
            class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
          >
            Lead'den Müşteri'ye dönüşen süre
          </h4>
          <p class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600">
            {{
              userInfo.customer_average_conversion_time.average_conversion_time
            }}
            gün
          </p>
        </div>
        <!-- End Stats -->
      </div>

      <vk-grid class="uk-child-width-expand@s mb-4">
        <vk-tabs>
          <vk-tabs-item title="Şifre">
            <form
              method="post"
              class="uk-form-stacked text-xs"
              style="max-width:700px;"
              @submit="profileFormSet()"
              action="javascript:void(0)"
            >
              <div class="uk-margin">
                <label>Telegram ID </label>
                <input
                  type="text"
                  name="password-current"
                  v-model="profileForm.telegram_id"
                  class="uk-input"
                />
                <span class="text-gray-400 mt-2 block"
                  >Telegram
                  <a href="https://t.me/viqqacrm_bot">@viqqacrm_bot</a> botuna
                  start yazın, o size bir id dönecek buraya o id yi yazdığınız
                  crmdeki bildirimleriniz telegram adresinizede gelecek.
                </span>
              </div>
              <div class="uk-margin">
                <label>Tema</label>
                <select v-model="profileForm.theme" class="uk-select">
                  <option value="head_navbar">Menü Üstte</option>
                  <option value="default">Menü Solda</option>
                </select>
              </div>
              <div class="uk-margin">
                <label>Dahili</label>
                <input
                  type="text"
                  name="password-current"
                  v-model="profileForm.dahili"
                  class="uk-input"
                />
              </div>
              <div class="uk-margin">
                <label>Kullanıcı Adı</label>
                <input
                  type="text"
                  name="password-current"
                  v-model="profileForm.username"
                  class="uk-input"
                />
              </div>

              <div class="uk-margin">
                <label>Mevcut Şifreniz</label>
                <input
                  type="password"
                  name="password-current"
                  v-model="profileForm.password"
                  class="uk-input"
                />
              </div>
              <div class="uk-margin">
                <label>Yeni Şifreniz</label>
                <input
                  name="password"
                  type="password"
                  autocomplete="new-password"
                  v-model="profileForm.new_password"
                  class="uk-input"
                />
              </div>
              <div class="uk-margin">
                <label>Yeni şifreniz (tekrar)</label>
                <input
                  name="password-2"
                  type="password"
                  v-model="profileForm.new_password_2"
                  class="uk-input"
                />
              </div>

              <button
                type="submit"
                class="bg-tile-500 text-green-50  cursor-pointer  hover:text-white px-3 py-2 rounded-lg"
              >
                Kaydet
              </button>
            </form>
          </vk-tabs-item>
          <vk-tabs-item title="Etkinliklerim">
            <table class="uk-table text-xs">
              <thead>
                <tr class="bg-gray-50">
                  <th>Güncellenen Lead Sayısı</th>
                  <th>Görüntülenen Lead Sayısı</th>
                  <th>Not alınan Lead Sayısı</th>
                  <th>Crmde ilk işlem zamanı</th>
                  <th>Crmde son işlem zamanı</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="activity.id"
                  v-for="activity in userInfo.activity"
                  class="border-b"
                >
                  <td>{{ activity.lead_interaction }}</td>
                  <td>{{ activity.lead_view }}</td>
                  <td>{{ activity.lead_note }}</td>
                  <td>{{ activity.start_action_time }}</td>
                  <td>{{ activity.last_action_time }}</td>
                </tr>
              </tbody>
            </table>
          </vk-tabs-item>
        </vk-tabs>
      </vk-grid>

      <!-- Bağlı Hesaplar: sunucuda Viqqa yapılandırılmamışsa hiç görünmez -->
      <div
        v-if="viqqa.enabled"
        class="border rounded-lg p-4 mb-4 text-sm"
        style="max-width:700px;"
      >
        <h4 class="text-lg font-semibold mb-3">Bağlı Hesaplar</h4>
        <div class="flex items-center justify-between space-x-4">
          <div>
            <div class="font-semibold">{{ viqqa.name }}</div>
            <div v-if="viqqa.linked" class="text-gray-500 text-xs mt-1">
              <span v-if="viqqa.linked.username"
                >@{{ viqqa.linked.username }}</span
              >
              <span v-if="viqqa.linked.username && viqqa.linked.email">
                ·
              </span>
              <span v-if="viqqa.linked.email">{{ viqqa.linked.email }}</span>
            </div>
            <div v-else class="text-gray-500 text-xs mt-1">
              Bağlı değil. Bağladığınızda "{{ viqqa.name }} ile giriş yap" ile
              girebilir, notları {{ viqqa.name }}'ya gönderebilirsiniz.
            </div>
          </div>
          <button
            v-if="viqqa.linked"
            type="button"
            class="border border-red-400 text-red-500 cursor-pointer px-3 py-2 rounded-lg whitespace-nowrap"
            :disabled="viqqa.busy"
            @click="viqqaUnlink()"
          >
            Bağlantıyı kaldır
          </button>
          <button
            v-else
            type="button"
            class="bg-tile-500 text-green-50 cursor-pointer hover:text-white px-3 py-2 rounded-lg whitespace-nowrap"
            :disabled="viqqa.busy"
            @click="viqqaLink()"
          >
            {{ viqqa.busy ? "Yönlendiriliyor…" : viqqa.name + " hesabını bağla" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../services/http";
import AuthService from "../services/auth";
import ViqqaService from "../services/viqqa";

import EventBus from "../components/Ui/EventBus";

export default {
  name: "profile",
  data() {
    return {
      userInfo: null,
      preferences: {
        system: {},
      },
      profileForm: {
        theme: localStorage.themeBackground,
        themeStyle: 1,
        themeDark: false,
      },
      viqqa: {
        enabled: false,
        name: "Viqqa",
        linked: null,
        busy: false,
      },
    };
  },
  created() {
    const justLinked = this.$route.query.viqqa === "linked";
    if (justLinked) {
      this.$router.replace({ path: this.$route.path }).catch(() => {});
    }
    this.loadViqqaStatus(justLinked);
    http.getUserDashboard().then((e) => {
      this.userInfo = e.data;
    });
    http.getAllPreferences().then((resp) => {
      this.preferences = resp.data.preferences;
    });
    this.profileForm.themeStyle = localStorage.themeStyle;
    this.profileForm.telegram_id = localStorage.telegram_id;
    this.profileForm.theme = localStorage.theme;
    this.profileForm.dahili = localStorage.dahili;
    this.profileForm.username = localStorage.userName;
    this.profileForm.themeDark = localStorage.themeDark;
    this.profileForm.themeMenuShow = localStorage.themeMenuShow;
  },
  methods: {
    loadViqqaStatus(justLinked) {
      AuthService.viqqaStatus()
        .then((resp) => {
          const d = resp.data || {};
          this.viqqa.enabled = !!(d.success && d.enabled);
          this.viqqa.name = d.name || "Viqqa";
          this.viqqa.linked = d.linked || null;
          if (justLinked && this.viqqa.linked) {
            this.$root.successMessage(this.viqqa.name + " hesabınız bağlandı");
          }
        })
        .catch(() => {
          this.viqqa.enabled = false;
        });
    },
    viqqaLink() {
      if (this.viqqa.busy) return;
      this.viqqa.busy = true;
      try {
        sessionStorage.setItem("viqqaFlow", "link");
      } catch (e) {
        // yoksay
      }
      AuthService.viqqaLinkStart()
        .then((resp) => {
          if (resp.data && resp.data.success && resp.data.url) {
            window.location.href = resp.data.url;
            return;
          }
          this.viqqa.busy = false;
          this.$root.errorMessage(
            (resp.data && resp.data.msg) || "Bağlantı başlatılamadı"
          );
        })
        .catch(() => {
          this.viqqa.busy = false;
          this.$root.errorMessage("Bağlantı başlatılamadı");
        });
    },
    viqqaUnlink() {
      if (this.viqqa.busy) return;
      if (
        !window.confirm(
          this.viqqa.name +
            " hesabınızın bağlantısı kaldırılsın mı? Bu hesapla artık CRM'e giriş yapamazsınız."
        )
      ) {
        return;
      }
      this.viqqa.busy = true;
      AuthService.viqqaUnlink()
        .then((resp) => {
          if (resp.data && resp.data.success) {
            this.viqqa.linked = null;
            ViqqaService.resetStatus();
            this.$root.successMessage("Bağlantı kaldırıldı");
          } else {
            this.$root.errorMessage(
              (resp.data && resp.data.msg) || "Bağlantı kaldırılamadı"
            );
          }
        })
        .catch(() => {
          this.$root.errorMessage("Bağlantı kaldırılamadı");
        })
        .finally(() => {
          this.viqqa.busy = false;
        });
    },
    editFormSet(val) {
      this.profileForm.theme = val.value;

      EventBus.$emit("themeBackground", val.value);
      localStorage.setItem("themeBackground", val.value);
      this.$forceUpdate();
    },
    styleSet(name, value) {
      EventBus.$emit(name, value);
      localStorage.setItem(name, value);
      this.$forceUpdate();
    },
    profileFormSet() {
      http.setProfile(this.profileForm).then((e) => {
        if (e.data.success) {
          if (e.data.dahili) {
            localStorage.theme = this.profileForm.theme;
            localStorage.setItem("userName", this.profileForm.username);

            EventBus.$emit("userName", this.profileForm.username);

            location.reload();

            this.$root.successMessage("Dahiliniz güncellenmiştir");
          } else if (e.data.telegram) {
            this.$root.successMessage("Telegram id güncellenmiştir");
          } else {
            this.$root.successMessage("Şifreniz güncellenmiştir");
          }
        } else {
          this.$root.errorMessage("Şifreniz güncellenemedi");
        }
      });
    },
  },
};
</script>

<style></style>
